// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hq-title[data-v-68befaa4] {\n  display: flex;\n  margin-bottom: 24px;\n}\n.hq-title .bg[data-v-68befaa4] {\n  width: 5px;\n  height: 24px;\n  background: #1677ff;\n  border-radius: 3px;\n  margin-right: 13px;\n}\n.hq-title .text[data-v-68befaa4] {\n  font-size: 18px;\n  color: #333;\n  line-height: 24px;\n}", ""]);
// Exports
module.exports = exports;
